var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublishedDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 34.125H34.3508L30.9566 37.5191L32.8125 39.375L39.375 32.8125L32.8125 26.25L30.9566 28.1059L34.3508 31.5H23.625V34.125ZM13.125 27.5625H19.6875V30.1875H13.125V27.5625ZM13.125 21H26.25V23.625H13.125V21Z",
    fill: "#303030",
    stroke: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4188 12.2063L23.2313 3.01875C22.9688 2.75625 22.7062 2.625 22.3125 2.625H9.1875C7.74375 2.625 6.5625 3.80625 6.5625 5.25V36.75C6.5625 38.1977 7.74112 39.375 9.1875 39.375H19.6875V36.75H9.1875V5.25H19.6875V13.125C19.6875 14.5688 20.8687 15.75 22.3125 15.75H30.1875V23.625H32.8125V13.125C32.8125 12.7312 32.6813 12.4688 32.4188 12.2063ZM22.3125 13.125V5.775L29.6625 13.125H22.3125Z",
    fill: "#303030",
    stroke: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishedDark);
export default __webpack_public_path__ + "static/media/published-dark.4794316b19b76df9785ea498b6e47d56.svg";
export { ForwardRef as ReactComponent };